const AcademicHistoryInfoConfirm = ({fields, graduate, viewMode, member, mt}) => {

  return (
    <>
              <h3>最終学歴</h3>
              <dl>
                <dt>最終学歴<span class="red">*</span></dt>
          <dd>{ viewMode ? member.academicHistory  :  fields.academicHistory } { mt == 14 || mt == 15 || mt == 16 || mt == 17 ? '' : (1 == graduate ? '大学' : '大学院') }&nbsp;</dd>
                <dt>卒業年度<span class="red">*</span></dt>
                <dd>{ viewMode ? member.classOfYear  :  fields.classOfYear } 年卒業</dd>
                <dt style={ (mt == 14 || mt == 15 || mt == 16 || mt == 17) ? {} : {"display": "none" }}>卒業予定<span class="red">*</span></dt>
                <dd style={ (mt == 14 || mt == 15 || mt == 16 || mt == 17) ? {} : {"display": "none" }}>{ viewMode ? member.expectedToGraduateOfYear  :  fields.expectedToGraduateOfYear } 年3月末</dd>
              </dl>
    </>
  );
}

export default AcademicHistoryInfoConfirm;
